<template>
  <div class="py-5">
    <v-list-item class="d-flex justify-center mx-2" width="100%">
      <v-list-item-avatar size="150" class="pa-0 ma-0">
        <v-img
          :src="shop.photograph"
          class="rounded-xl"
          max-width="100%"
          height="100%"
        />
      </v-list-item-avatar>
    </v-list-item>
    <div class="text-h4 d-flex align-center justify-center pa-0 mt-1">
      {{ shop.shop_name }}
    </div>
    <div class="d-flex justify-center">
      <v-btn
        v-if="shop.facebook_link"
        icon
        class="ma-2 mx-2"
        target="_blank"
        :href="$utils.processURL(shop.facebook_link)"
      >
        <v-icon size="30" color="blue">mdi-facebook</v-icon>
      </v-btn>
      <v-btn
        v-if="shop.instagram_link"
        icon
        class="ma-2 mx-2"
        target="_blank"
        :href="$utils.processURL(shop.instagram_link)"
      >
        <v-icon size="30" color="pink">mdi-instagram</v-icon>
      </v-btn>
      <v-btn
        v-if="shop.whatsapp_link"
        icon
        class="ma-2 mx-2"
        target="_blank"
        :href="$utils.processWhatsapp(shop.whatsapp_link)"
      >
        <v-icon size="30" color="green">mdi-whatsapp</v-icon>
      </v-btn>
      <v-btn
        v-if="shop.telephone"
        icon
        class="ma-2 mx-2"
        target="_blank"
        :href="$utils.processURL(shop.telephone)"
      >
        <v-icon size="30">mdi-phone</v-icon>
      </v-btn>
    </div>

    <v-divider class="my-2" />

    <v-btn
      v-if="!admin && $store.state.user.id == shop.user_id"
      color="#4B2A66"
      elevation="3"
      small
      block
      dark
      class="py-4 mb-2"
      :to="{
        name: 'admin/home',
        params: { shop_url: $route.params.shop_url },
      }"
    >
      Administrar negócio
      <v-icon class="ml-2">mdi-tune</v-icon>
    </v-btn>

    <v-btn
      v-if="!webShareApiSupported && admin"
      color="#4B2A66"
      elevation="3"
      small
      block
      class="py-4"
      dark
      @click="share_shop = true"
    >
      Compartilhar Loja
      <v-icon class="ml-2">mdi-share</v-icon>
    </v-btn>
    <v-btn
      v-if="webShareApiSupported && admin"
      color="#4B2A66"
      elevation="3"
      small
      block
      class="py-4"
      dark
      href="javascript:void(0)"
      @click="share()"
    >
      Compartilhar Loja
      <v-icon class="ml-2">mdi-share</v-icon>
    </v-btn>
    <div class="text-caption mt-1" style="color:#4B2A66">
      Localização:
    </div>
    <div class="text-caption" v-if="shop.street && shop.number && shop.neighborhood">
      R.{{ shop.street }}, {{ shop.number }} - {{ shop.neighborhood }}
    </div>
    <div class="text-caption">{{ city.name }} - {{ state }}</div>

    <template v-if="shop.cnpj">
      <div class="text-caption  mt-2" style="color:#4B2A66">CNPJ:</div>
      <div class="text-caption">
        {{ shop.cnpj }}
      </div>
    </template>

    <template v-if="shop.email">
      <div class="text-caption mt-2" style="color:#4B2A66">Email:</div>
      <div class="text-caption">
        {{ shop.email }}
      </div>
    </template>

    <template v-if="shop.description">
      <div class="text-caption  mt-2" style="color:#4B2A66">
        Descrição:
      </div>
      <div text-caption>{{ shop.description }}</div>
    </template>

    <!--<v-list dense>
                  <v-list-item v-for="item in items" :key="item.title" link>
                    <v-list-item-content>
                      <v-list-item-title class="pink--text text--darken-2">{{
                        item.title
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>-->
    <template v-if="admin">
      <v-list class="font-weight-bold" dense>
        <v-list-item link :to="{ name: 'admin/home' }" exact>
          <v-list-item-content>
            <v-list-item-title style="color:#4B2A66">
              Produtos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'admin/messages' }" exact>
          <v-list-item-content>
            <v-list-item-title style="color:#4B2A66">
              Caixa de Entrada
              <li>{{ received }} mensagens não visualizadas</li>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'admin/edit' }" exact>
          <v-list-item-content>
            <v-list-item-title style="color:#4B2A66">
              Editar Loja
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          :to="{ name: 'shop', params: { shop_url: $route.params.shop_url } }"
          exact
        >
          <v-list-item-content>
            <v-list-item-title style="color:#4B2A66">
              Visualizar Loja
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <v-dialog v-model="share_shop" max-width="500">
      <v-card>
        <v-card-title class="headline justify-center">
          Compartilhe seu negócio!
        </v-card-title>

        <v-container>
          <v-card height="30" class="d-flex justify-center align-center">
            <div class="text-subtitle-2">
              https://olhadela.digital/negocio/{{ $route.params.shop_url }}
            </div>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>                

<script>
export default {
  props: {
    shop: { required: true, type: Object },
    admin: { default: false, type: Boolean },
  },
  data: () => ({
    id_city: "",
    state: "",
    city: [],
    received: undefined,
    share_shop: false,
  }),
  computed: {
    webShareApiSupported() {
      return navigator.share;
    },
  },
  mounted() {
    this.$axios.get("/shop/" + this.$route.params.shop_url).then((response) => {
      this.id_city = response.data.city_id;
      this.$axios.get("/shop/message/" + response.data.id).then((response) => {
        this.received = response.data[1];
      });
      this.$axios.get("/city/" + this.id_city).then((response) => {
        this.city = response.data;
        this.$axios.get("/state/" + response.data.state_id).then((response) => {
          this.state = response.data.uf;
        });
      });
    });
  },
  methods: {
    share() {
      if (navigator.share !== undefined) {
        navigator
          .share({
            title: "Olhadela",
            text:
              "Venha conferir a loja " + this.shop.shop_name + " no olhadela:",
            url:
              "https://olhadela.digital/negocio/" + this.$route.params.shop_url,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }
    },
  },
};
</script>
